import { LabMDM } from "./lab";

export class Project{
	_id: string;
	projectId: string;
	projectName: string;
	lab: LabMDM;
	active: boolean;
	duplicate: boolean;
	sender: string;
	identifier: string[];
	newUI = true;
	updateWeatherbys? = false;
	activationCheck? = false;
	manualWorkflow?= false;
}